import angular from 'angular';

import component from './mobile-ordering.component';

const MobileOrdering = angular
    .module('control-room.menus.components.kitchen-manage.components.mobile-ordering', [])
    .component('crMobileOrdering', component);

export default MobileOrdering;